import React from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

// Define the case types and their keys for the dropdown
const CASE_TYPES = [
    { label: "Summary Suit", value: "summary_suit" },
    { label: "Commercial Suit", value: "comm_suit" },
    { label: "Execution Petition", value: "pre_ep" },
    { label: "Mediation Application", value: "mediation_application" },
    { label: "Interim Application", value: "interim_application" },
    { label: "Loan Recall Notice", value: "loan_recall_notice" },
    { label: "Sec 95", value: "sec_95" }
];

// The component only deals with caseTypeKey/setCaseTypeKey (no amount props)
const RequestCourtFeesModal = ({ show, onHide, selectedCase, caseTypeKey, setCaseTypeKey, submitRequestCourtFees, loading }) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title>
        Request Court Fees 
        {selectedCase && (
            <div className="text-muted fs-6 mt-1">
                {selectedCase.customer_name} ({selectedCase.lan_number})
            </div>
        )}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Case Document Type (type_of_case) *</Form.Label>
          <Form.Select
            value={caseTypeKey}
            onChange={(e) => setCaseTypeKey(e.target.value)}
            disabled={loading}
          >
            {/* Value is empty string "" to keep the button disabled until a real selection is made */}
            <option value="">Select the document type key</option> 
            {CASE_TYPES.map((type) => (
                <option key={type.value} value={type.value}>
                    {type.label} ({type.value})
                </option>
            ))}
          </Form.Select>
        </Form.Group>
        
        <p className="text-muted small">
            A request will be sent to the backend for the selected document type.
        </p>
      </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide} disabled={loading}>Close</Button>
      <Button 
        variant="primary" 
        onClick={submitRequestCourtFees} 
        // Button is disabled if loading or if a key hasn't been selected (caseTypeKey is "")
        disabled={loading || !caseTypeKey}
      >
        {loading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />}
        {loading ? 'Sending...' : 'Send Request'}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default RequestCourtFeesModal;